
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hottest-deals",
      function () {
        return require("private-next-pages/hottest-deals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hottest-deals"])
      });
    }
  